import { ReactNode } from "react";
import { STYLE } from "@jasper/shared";
import { NotificationBadge } from "./NotificationBadge";
import { INDENT_STEP } from "./helpers/navMenu";

export const SectionHeader = (props: {
  title: string;
  icon?: ReactNode;
  notificationNumber?: number;
  indent?: number;
  active?: boolean;
  onClick?: () => void;
  trailing?: ReactNode;
  ariaExpanded?: boolean;
  ariaControls?: string;
}) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        cursor: props.onClick ? "pointer" : "default",
        color: props.active ? STYLE.primary : "#050027",
        fontWeight: "bold",
        textAlign: "left",
        paddingLeft: `${(props.indent ?? 0) * INDENT_STEP}px`,
      }}
      onClick={props.onClick}
      role={props.onClick ? "button" : undefined}
      tabIndex={props.onClick ? 0 : undefined}
      aria-expanded={props.ariaExpanded}
      aria-controls={props.ariaControls}
      onKeyDown={
        props.onClick
          ? e => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                props.onClick?.();
              }
            }
          : undefined
      }
    >
      {props.icon && (
        <span style={{ display: "flex", flexShrink: 0 }}>{props.icon}</span>
      )}
      <span style={{ overflowWrap: "break-word" }}>
        {props.title.replaceAll("_", " ")}
      </span>
      {props.notificationNumber ? (
        <NotificationBadge count={props.notificationNumber} />
      ) : null}
      {props.trailing && (
        <span style={{ marginLeft: "auto", display: "flex" }}>
          {props.trailing}
        </span>
      )}
    </div>
  );
};
